import Vue from "vue";
import App from "./App";
import "./styles.scss";
import "./index.html";

import PlattarFrame from "./components/PlattarFrame.vue";
import CameraButtons from "./components/CameraButtons.vue";
import ProductButtons from "./components/ProductButtons.vue";
import PageVideo from "./components/PageVideo";

import Vue2TouchEvents from "vue2-touch-events";
import ContentFrame from "./components/ContentFrame";
import DebugPanel from "./components/DebugPanel";
import VueObserveVisibility from "vue-observe-visibility";
import ModelEmbed from "./components/ModelEmbed";
import ProductPage from "./components/ProductPage.vue";
import SwiperContent from "./components/SwiperContent";
import VueVideoPlayer from "vue-video-player";
import "video.js/dist/video-js.css";

//import VueAwesomeSwiper from "vue-awesome-swiper";
import {
  Swiper as SwiperClass,
  Pagination,
  Navigation,
  Mousewheel,
  Autoplay,
} from "swiper/swiper.esm";
import getAwesomeSwiper from "vue-awesome-swiper/dist/exporter";
import "@google/model-viewer/dist/model-viewer-legacy.js";
import "focus-visible";
Vue.config.ignoredElements = ["model-viewer"];

SwiperClass.use([Pagination, Mousewheel, Navigation, Autoplay]);
Vue.use(getAwesomeSwiper(SwiperClass));
const {
  Swiper,
  SwiperSlide
} = getAwesomeSwiper(SwiperClass);

import "swiper/swiper-bundle.css";

//Vue.use(VueAwesomeSwiper);
Vue.use(VueObserveVisibility);
Vue.component("swiper-content", SwiperContent);
Vue.component("model-embed", ModelEmbed);
Vue.component("plattar-frame", PlattarFrame);
Vue.component("camera-buttons", CameraButtons);
Vue.component("product-buttons", ProductButtons);
Vue.component("content-frame", ContentFrame);
Vue.component("debug-panel", DebugPanel);
Vue.component("page-video", PageVideo);
Vue.component("product-page", ProductPage);

Vue.use(Vue2TouchEvents);
Vue.use(VueVideoPlayer,
  /* {
  options: global default options,
  events: global videojs events
} */
);

const comms = new PlattarViewerCommunicator();
new Vue({
  el: "#app",
  data: {
    comms: comms,
    clickAudio: null,
  },
  methods: {
    playClick() {
      this.clickAudio.play();
    },
  },
  render: (h) => h(App),
  created() {
    this.clickAudio = new Audio("click.mp3");
  },
});